/* tslint:disable:max-line-length */
import * as React from 'react';
import pure from 'recompose/pure';

class ArrowDownIcon extends React.Component<{ style: any }> {
  render() {
    return <svg
      fill="currentcolor"
      viewBox="0 0 60 60" {...this.props}>
      <g id="Group">
        <path
          d="M30,12 L30,12 C31.1045695,12 32,12.8954305 32,14 L32,45 C32,46.1045695 31.1045695,47 30,47 L30,47 C28.8954305,47 28,46.1045695 28,45 L28,14 C28,12.8954305 28.8954305,12 30,12 Z"
          id="Rectangle-8"
        />
        <path
          d="M36.3085233,28.3447594 L36.3085234,28.3447594 C37.3987979,28.3447594 38.28264,29.2286015 38.28264,30.318876 C38.28264,30.3274475 38.2825842,30.336019 38.2824725,30.3445898 L38.0445322,48.6103265 C38.0328459,49.5074382 37.2961195,50.2252174 36.3990077,50.2135311 C36.3203838,50.2125069 36.241938,50.2057756 36.1642889,50.1933903 L35.9934993,50.1661488 C35.0228106,50.0113209 34.3085234,49.1740736 34.3085234,48.1911147 L34.3085233,30.3447593 C34.3085233,29.2401898 35.2039538,28.3447593 36.3085233,28.3447593 C36.3085233,28.3447593 36.3085233,28.3447593 36.3085233,28.3447593 Z"
          id="Rectangle-8"
          transform="translate(36.295582, 39.279216) rotate(-315.000000) translate(-36.295582, -39.279216) "
        />
        <rect
          id="Rectangle-8"
          transform="translate(23.207107, 39.207107) rotate(-225.000000) translate(-23.207107, -39.207107) "
          x="21.2071068"
          y="28.1862915"
          width="4"
          height="22.0416306"
          rx="2"
        />
      </g>
    </svg>;
  }
}

const Icon = pure(ArrowDownIcon);
Icon.displayName = 'ArrowDownIcon';
export default Icon;
